import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import whiteLogo from '../../assets/svgs/logo-white.svg';
import iconSprite from '../../assets/icon-sprite.svg';

class TopNav extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleOpenClick = () => {
    this.setState({ show: true });
  };

  handleCloseClick = () => {
    this.setState({ show: false });
  };

  render() {
    const { business, user, page } = this.props;
    const { show } = this.state;

    return (
      <nav className="navbar topnav">
        <div className="d-inline-flex align-items-center">
          <button
            className="navbar-toggler d-lg-none"
            type="button"
            onClick={this.handleOpenClick}>
            <svg width="24" height="24">
              <use xlinkHref={iconSprite + '#menu'}></use>
            </svg>
          </button>
          <div className="pageTitle d-none d-lg-block">
            {page ? (
              <h3
                className="pageTitle__header"
                style={{ textTransform: 'capitalize' }}>
                {page}
              </h3>
            ) : (
              <h3 className="pageTitle__header">
                Hello,&nbsp;
                {business.name}
              </h3>
            )}
          </div>
        </div>
        <div className="d-flex align-items-center">
          <div>
            <p
              className="pageTitle__header my-0 mx-2 d-lg-block  d-md-block d-none"
              style={{ fontSize: '1rem' }}>
              {business.name}
            </p>
          </div>
          <div className="profile-picture">
            <Link to="#" className="image-container" hidden={!user?.photo_url}>
              <img src={user?.photo_url} alt="" />
            </Link>
            <Link
              to="#"
              className="image-container emptyImageContainer"
              hidden={user?.photo_url}>
              <span>{business.name?.toUpperCase().slice(0, 1)}</span>
            </Link>
          </div>
        </div>

        <div
          className="menu-overlay d-lg-none"
          id="mobilenav"
          style={{ display: show ? 'block' : 'none' }}>
          <div
            className={`topnav__slideout sidebar bg-secondary animate__animated ${
              show
                ? 'animate__slideInLeft'
                : 'animate__animated animate__fadeOut'
            }`}>
            <header className="sidebar__header">
              <div className="sidebar__header--container">
                <img src={whiteLogo} height="30" alt="P2Vest Logo" />
                <div
                  role="button"
                  className="close-btn btn-secondary-link"
                  onClick={this.handleCloseClick}>
                  <svg width="48" height="48">
                    <use xlinkHref={iconSprite + '#close-icon'}></use>
                  </svg>
                </div>
              </div>
            </header>
            <main className="sidebar__main">
              <ul className="nav flex-column">
                <li className="nav-item" hidden={business.status !== 'active'}>
                  <Link
                    className={
                      page === 'dashboard' ? 'nav-link active-page' : 'nav-link'
                    }
                    to="/dashboard">
                    <svg width="20" height="20">
                      <use xlinkHref={iconSprite + '#dashboard'}></use>
                    </svg>
                    Home
                  </Link>
                </li>
                <li
                  className="nav-item"
                  hidden={
                    business.status !== 'active' || user.type !== 'business'
                  }>
                  <Link
                    className={
                      page === 'analysis' ? 'nav-link active-page' : 'nav-link'
                    }
                    to="/analysis">
                    <svg width="20" height="20">
                      <use xlinkHref={iconSprite + '#analysis'}></use>
                    </svg>
                    Analysis
                  </Link>
                </li>
                <li
                  className="nav-item"
                  hidden={
                    business.status !== 'active' || user.type !== 'business'
                  }>
                  <Link
                    className={
                      page === 'calculator'
                        ? 'nav-link active-page'
                        : 'nav-link'
                    }
                    to="/calculator">
                    <svg width="20" height="20">
                      <use xlinkHref={iconSprite + '#calculator'}></use>
                    </svg>
                    Calculator
                  </Link>
                </li>
                <li
                  className="nav-item"
                  hidden={
                    business.status !== 'active' || user.type !== 'business'
                  }>
                  <Link
                    className={
                      page === 'users' ? 'nav-link active-page' : 'nav-link'
                    }
                    to="/users">
                    <svg width="20" height="20">
                      <use xlinkHref={iconSprite + '#customers'}></use>
                    </svg>
                    Users
                  </Link>
                </li>
                <li
                  className="nav-item"
                  hidden={
                    business.status !== 'active' || user.type !== 'business'
                  }>
                  <Link
                    className={
                      page === 'agents' ? 'nav-link active-page' : 'nav-link'
                    }
                    to="/agents">
                    <svg width="20" height="20">
                      <use xlinkHref={iconSprite + '#agents'}></use>
                    </svg>
                    Agents
                  </Link>
                </li>
                <li
                  className="nav-item"
                  hidden={
                    business.status !== 'active'
                    || user.type == 'business'
                    || user.type == 'initiator'
                  }>
                  <Link
                    className={
                      page === 'validations'
                        ? 'nav-link active-page'
                        : 'nav-link'
                    }
                    to="/validations">
                    <svg width="20" height="20">
                      <use xlinkHref={iconSprite + '#validations'}></use>
                    </svg>
                    Validations
                  </Link>
                </li>
                <li
                  className="nav-item"
                  hidden={
                    business.status !== 'active'
                    || (user.type !== 'business' && user.type !== 'initiator')
                  }>
                  <Link
                    className={
                      page === 'loans' ? 'nav-link active-page' : 'nav-link'
                    }
                    to="/loans">
                    <svg width="20" height="20">
                      <use xlinkHref={iconSprite + '#loans'}></use>
                    </svg>
                    Loans
                  </Link>
                </li>
                <li
                  className="nav-item"
                  hidden={
                    business.status !== 'active' || user.type !== 'business'
                  }>
                  <Link
                    className={
                      page === 'loan-requests'
                        ? 'nav-link active-page'
                        : 'nav-link'
                    }
                    to="/loan-requests">
                    <svg width="20" height="20">
                      <use xlinkHref={iconSprite + '#loanrequest'}></use>
                    </svg>
                    Loans Request
                  </Link>
                </li>
                <li
                  className="nav-item"
                  hidden={
                    business.status !== 'active' || user.type !== 'business'
                  }>
                  <Link
                    className={
                      page === 'transactions'
                        ? 'nav-link active-page'
                        : 'nav-link'
                    }
                    to="/transactions">
                    <svg width="20" height="20">
                      <use xlinkHref={iconSprite + '#menu'}></use>
                    </svg>
                    Transactions
                  </Link>
                </li>
                <li
                  className="nav-item"
                  hidden={
                    business.status !== 'active' || user.type !== 'business'
                  }>
                  <Link
                    className={
                      page === 'payments' ? 'nav-link active-page' : 'nav-link'
                    }
                    to="/payments">
                    <svg width="20" height="20">
                      <use xlinkHref={iconSprite + '#payments'}></use>
                    </svg>
                    Payments
                  </Link>
                </li>
                <li
                  className="nav-item"
                  hidden={
                    business.status !== 'active' || user.type !== 'business'
                  }>
                  <Link
                    className={
                      page === 'reports' ? 'nav-link active-page' : 'nav-link'
                    }
                    to="/reports">
                    <svg width="20" height="20">
                      <use xlinkHref={iconSprite + '#report'}></use>
                    </svg>
                    Loan Report
                  </Link>
                </li>

                <li className="nav-item" hidden={business.status !== 'active'}>
                  <Link
                    className={
                      page === 'insurance' ? 'nav-link active-page' : 'nav-link'
                    }
                    to="/insurance">
                    <svg width="20" height="20">
                      <use xlinkHref={iconSprite + '#insurance'}></use>
                    </svg>
                    Insurance
                  </Link>
                </li>

                <li className="nav-item" hidden={business.status !== 'active'}>
                  <Link
                    className={
                      page === 'commissions' ? 'nav-link active-page' : 'nav-link'
                    }
                    to="/commissions">
                    <svg width="20" height="20">
                      <use xlinkHref={iconSprite + '#commissions'}></use>
                    </svg>
                    Commissions
                  </Link>
                </li>

                <li className="nav-item" hidden={business.status !== 'active'}>
                  <Link
                    className={
                      page === 'settings' ? 'nav-link active-page' : 'nav-link'
                    }
                    to="/settings">
                    <svg width="20" height="20">
                      <use xlinkHref={iconSprite + '#settings'}></use>
                    </svg>
                    Settings
                  </Link>
                </li>
              </ul>
            </main>
            <footer className="sidebar__footer">
              <ul className="nav flex-column">
                <li className="nav-item">
                  <Link className="nav-link" href="">
                    <svg width="20" height="20">
                      <use xlinkHref={iconSprite + '#logout'}></use>
                    </svg>
                    Logout
                  </Link>
                </li>
              </ul>
            </footer>
          </div>
        </div>
      </nav>
    );
  }
}

const mapStateToProps = (state) => ({
  business: state.account?.business || {},
  user: state.account?.user || {},
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TopNav);
